import { Box, IconButton, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { CloseIcon, WarningTriangleIcon } from "../../../../../../components/Icons";
import { useLocalStorage } from "../../../../../../hooks";

const STORAGE_KEY = "isVetcoveOrderNoteDismissed";

const Note = () => {
  const [isDismissed, setIsDismissed] = useLocalStorage(STORAGE_KEY, false);

  const handleClose = useCallback(() => {
    setIsDismissed(true);
  }, [setIsDismissed]);

  if (isDismissed) {
    return null;
  }

  return (
    <Box className="relative flex items-center gap-4 bg-white p-3 pr-10 rounded-xl border border-gray-3">
      <Box
        width={32}
        height={32}
        className="flex-shrink-0 flex justify-center items-center rounded-full bg-gv-yellow-light"
      >
        <WarningTriangleIcon width={16} height={16} />
      </Box>
      <Typography variant="body1" className="flex-1">
        Orders placed through the Online Pharmacy are synced here automatically, but it may take a short time for them
        to appear in your Order History.
      </Typography>
      <IconButton
        onClick={handleClose}
        size="small"
        aria-label="Dismiss note"
        sx={{ position: "absolute", right: 4, top: 4, color: "black.main" }}
      >
        <CloseIcon width={20} height={20} />
      </IconButton>
    </Box>
  );
};

export default Note;
